import { Alignment, Displaying, IconButton, Spacing, Typography } from "@bonusx-global/bx-design-system";
import { TimesSolid } from "@bonusx-global/bx-icons";
import Box from "@mui/material/Box";

export const CLOSE_BUTTON_ID = "ai-response-feedback-close-button";

interface AiResponseFeedbackTitleProps {
  text: string;
  showCloseButton?: boolean;
  onCloseClick?: () => void;
}

function AiResponseFeedbackTitle({
  text,
  onCloseClick,
  showCloseButton = false,
}: Readonly<AiResponseFeedbackTitleProps>): JSX.Element {
  return (
    <Box display={Displaying.flex} alignItems={Alignment.center} gap={Spacing[250]}>
      {showCloseButton && (
        <IconButton id={CLOSE_BUTTON_ID} onClick={onCloseClick}>
          <TimesSolid />
        </IconButton>
      )}
      <Typography variant={"caption"}>{text}</Typography>
    </Box>
  );
}

export default AiResponseFeedbackTitle;
